import * as yup from "yup";
export const validationSchema = yup.object().shape({
  user: yup.string().required("Agent Name is required"),
  expiration: yup.date().required("Live date is required"),
  streetAddr: yup.string().required("Address is required"),
  city: yup.string().required("City is required"),
  state: yup.string().required("State is required"),
  zip: yup.string().required("Zip is required"),
  beds: yup
    .string()
    .when("propertyCategory", {
      is: (val) => val !== "land",
      then: (schema) =>
        schema
          .matches(/^(10|[0-9])$/, "Beds must be a whole number between 0 and 10")
          .required("Beds are required"),
      otherwise: (schema) =>
        schema
          .matches(/^(10|[0-9])?$/, "Beds must be a whole number between 0 and 10")
          .notRequired(),
    }),
  baths: yup
    .string()
    .when("propertyCategory", {
      is: (val) => val !== "land",
      then: (schema) =>
        schema
          .matches(
            /^(10|\d(\.\d)?|[0-9])$/,
            "Baths must be a number or decimal up to one decimal place and must not exceed 10."
          )
          .required("Baths are required"),
      otherwise: (schema) =>
        schema
          .matches(
            /^(10|\d(\.\d)?|[0-9])?$/,
            "Baths must be a number or decimal up to one decimal place and must not exceed 10."
          )
          .notRequired(),
    }),
  price: yup
    .number()
    .transform((value, originalValue) => (originalValue === "" ? undefined : value))
    .typeError("Price must be a number")
    .required("Price is required"),
  sqFt: yup
    .number()
    .transform((value, originalValue) => (originalValue === "" ? undefined : value))
    .typeError("Square feet must be a number")
    .required("Square feet is required"),
  propertyType: yup.string().required("Property Type is required"),
});

export const validateLink = yup.object().shape({
  url: yup
    .string()
    .matches(
      /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:\d+)?(\/[^\s]*)?(\?[^\s#]*)?(#[^\s]*)?$/,
      "Please enter a valid URL."
    )
    .required("URL is required."),
  title: yup.string(),
});
